import { Country } from '~/Api/Country';

export enum ErrorCode {
	calculationRequiresAtLeastOneProductList = 'romania-max-price-calculation-requires-at-least-one-product-list',
	cannotChangeSettingsForNonMemberProducts = 'romania-max-price-calculation-cannot-change-settings-for-non-member-products',
	exportLimitExceeded = 'romania-max-price-export-limit-exceeded',
	illegalPriceTypeSelected = 'romania-max-price-illegal-price-type-selected',
	requiredProductSettingsMissing = 'romania-max-price-calculation-required-product-settings-is-missing',
	requiresMaxOneProductPerDataSource = 'romania-max-price-calculation-requires-at-most-one-product-for-each-datasource',
	requiresMaxOneReferenceProduct = 'romania-max-price-calculation-requires-at-most-one-product-for-each-country',
	requiresMinOneReferenceProduct = 'romania-max-price-calculation-requires-at-least-one-reference-country-product',
	requiresReferenceSettings = 'romania-max-price-calculation-requires-reference-settings',
}

export class Error {
	public constructor(
		public code: string,
		public productId: string | null,
		public productGroupId: string | null,
		public duplicateCountries: Country[]
	) {}
}
